<template>
  <!-- div v-if="true || $store.state.userData" -->
  <div>
    <div class="row">
      <div class="col-sm-6">
        <overview-card>
          <div class="text-left card-title" style="margin-top: 0em;" slot="header">
             Overview
          </div>
          <div class="numbers" slot="content">
            <p>Overall Balance</p>
            {{ (parseFloat(( data.overview.overallBalance) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ) }}
          </div>
          <div class="numbers" slot="content">
            <p>Active Participants</p>
            {{ data.overview.activeParticipants.toLocaleString('en-US') }}
          </div>
          <div class="numbers" slot="content">
            <p>Median Balance</p>
            {{ (parseFloat((data.overview.medianBalance) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ) }}
          </div>
          <div class="stats" slot="footer">
            As of {{ moment(getYesterday()).format('MMMM D, YYYY') }},
            pending investment gains/losses posted at month end
          </div>
        </overview-card>
      </div>
      <div class="col-sm-6">
        <summary-card>
    			<span slot="title-content">
        	  <span class="text-left card-title" slot="title">Summary</span>
              <span slot="title-label" class="pull-right">
                <el-select
                  class="select-success"
                  size="small"
                  v-model="summaryRange"
                  @change="updateSummaryRange($event)">
                  <el-option
                    v-for="item in summaryRanges"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
             </span>
           </span>
          <div slot="title-content" class="trustOverviewSummary">
            <table style="width: 100%;" :class="[this.summaryLoading ? 'opaque' : '']">

              <tr>
                <td>
                  <strong>Beginning Balance as of {{ moment(data.summary.dateStart).format('MMMM D, YYYY') }}: </strong>
                </td>
                <td class="amt">
                  {{ (parseFloat((data.summary.startBalance) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ) }}
                </td>
              </tr>
              <tr>
                <td class="inner">
                  Contributions
                </td>
                <td class="amt">
                  {{ (parseFloat((data.summary.contributions) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ) }}
                </td>
              </tr>
              <tr>
                <td class="inner">
                  Distributions
                </td>
                <td class="amt">
                  {{ (parseFloat((data.summary.distributions) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ) }}
                </td>
              </tr>
              <tr>
                <td class="inner">
                  Earnings
                </td>
                <td class="amt">
                  {{ (parseFloat((data.summary.earnings) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ) }}
                </td>
              </tr>
              <tr>
                <td class="inner">
                  Fees
                </td>
                <td class="amt">
                  {{ (parseFloat((data.summary.fees) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ) }}
                </td>
              </tr>
              <tr style="border-top: 1px solid #000;">
                <td>
                  <strong>Ending Balance as of {{ moment(data.summary.dateEnd).format('MMMM D, YYYY') }}: </strong>
                </td>
                <td class="amt">
                  {{ (parseFloat((data.summary.endBalance) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' } ) }}
                </td>
              </tr>
            </table>
          </div>
        </summary-card>
      </div>
    </div>
  </div>
</template>
<script>
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import OverviewCard from 'src/components/UIComponents/Cards/OverviewCard.vue'
  import SummaryCard from 'src/components/UIComponents/Cards/SummaryCard.vue'

  export default {
    components: {
      StatsCard,
    //  ChartCard,
      OverviewCard,
      SummaryCard
    },
    methods: {
      getYesterday () {
        var yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1)
        return yesterday
      },
      getInfo: function () {
        if (this.$store.state.managerData.GroupId !== 0) {
          var url = '/manager/groups/' + this.$store.state.managerData.GroupId + '/overview'
          this.$http.get(url)
          .then(response => {
            this.data.overview = {
              'overallBalance': response.data.overallBalance,
              'activeParticipants': response.data.activeParticipants,
              'medianBalance': response.data.medianBalance
            }
          })
        } else { // do not commit this
          url = '/manager/viewGroup/1'
          this.$http.get(url)
          .then(response => {
            this.data = response.data
          })
        }
      },
      updateSummaryRange: function (event) {
        if (this.$store.state.managerData.GroupId !== 0) {
          this.summaryLoading = true
          var url = '/manager/groups/' + this.$store.state.managerData.GroupId + '/summary/' + this.summaryRange
          this.$http.get(url)
          .then(response => {
            this.data.summary = response.data.totals
            this.data.summary.dateStart = response.data.dateStart
            this.data.summary.dateEnd = response.data.dateEnd
            this.data.summary.loaded = true
            this.summaryLoading = false
          })
        } else { // do not commit this
          url = '/manager/group/1/summary/' + this.summaryRange
          this.$http.get(url)
          .then(response => {
            this.data = response.data
          })
        }
      }
    },
    mounted () {
      // Initialize from what was loaded from login
      this.data.overview = this.$store.state.managerData.overview
      // 0000398: SRP-MIC Online Project - for now, only show the all option for SRP-MIC
      if (this.$store.state.managerData.GroupId === 1) {
        this.summaryRange = 'all'
        this.summaryRanges = this.summaryRanges.splice(4, 1)
      }
      // Only load summary data if it hasn't been previously loaded
      if (!this.data.summary.loaded) {
        this.updateSummaryRange({})
      }
    },
    data () {
      return {
        data: {
          overview: {
            overallBalance: 0,
            activeParticipants: 0,
            medianBalance: 0
          },
          summary: {
            startBalance: 0,
            contributions: 0,
            distributions: 0,
            earnings: 0,
            fees: 0,
            endBalance: 0,
            loaded: false
          }
        },
        summaryRanges: [{
          value: '1',
          label: '1 Month'
        }, {
          value: '3',
          label: '3 Months'
        }, {
          value: 'ytd',
          label: 'YTD'
        }, {
          value: '1yr',
          label: '1 Year'
        }, {
          value: 'all',
          label: 'All Time'
        }],
        summaryRange: '1',
        summaryLoading: false
      }
    }
  }
</script>
<style>
.el-input__inner {
  background-color: #fff;
  border-color: #7a9e9f !important;
  border-width: 2px;
  border-radius: 20px;
  color: #7a9e9f;
}
.inner {
    padding-left: 10%;
}
.amt {
	text-align: right;
}

.opaque {
    visibility: hidden;
}

/* Same as on Overview.vue cards. Note that on those cards the font is specified
 * as an inline style. Should update to use this class at some point.
 */
.card-title {
    font-size: 1.5em;
}

/* Table on Summary card */
div.trustOverviewSummary table {
    font-size: 1.2em;
    margin-top: 1em;
}

div.trustOverviewSummary table td {
    vertical-align: top;
    padding-bottom: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/TrustOverview.vue